import { render, staticRenderFns } from "./ArrowRightSVG.vue?vue&type=template&id=1b3fcf16&scoped=true&"
import script from "./ArrowRightSVG.vue?vue&type=script&lang=js&"
export * from "./ArrowRightSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3fcf16",
  null
  
)

export default component.exports